<div tabindex="0" class="billing-card row" *ngIf="data">
    <div class="billing-card__header col-xs-12">
        {{data.title}}
    </div>

    <ng-container *ngIf="!editting">
        <div class="col-sm-12 form-group billing-card__content">
            <ng-container *ngIf="billingData && billingData?.last_name && billingData?.street; else emptyForm">
                <div class="billing-card__form row">
                    <div class="col-xs-1">
                        <i class="far fa-user-circle form-icon" aria-hidden="true"></i>
                    </div>
                    <div class="col-xs-11">
                        <label class="billing-card__form__label">
                            {{data.fullnameLabel}}
                        </label>
                        <span class="billing-card__form__content">
                            {{billingData.last_name}} {{billingData.first_name}}
                        </span>
                    </div>
                </div>

                <div class="billing-card__form row">
                    <div class="col-xs-1">
                        <i class="form-icon far fa-home-lg-alt"></i>
                    </div>
                    <div class="col-xs-11">
                        <label class="billing-card__form__label">
                            {{data.addressLabel}}
                        </label>
                        <span class="billing-card__form__content">
                            {{billingData.street}}
                        </span>
                    </div>
                </div>
            </ng-container>

            <ng-template #emptyForm>
                <div name="folder" color="darkBlue" class="billing-card__icon">
                    <svg width="56" height="37" viewBox="0 0 56 37" fill="none" xmlns="http://www.w3.org/2000/svg"
                         style="color: rgb(32, 42, 77); height: 60px; width: 60px; object-position: center center;">
                        <path d="M28.592 3.09L27.482 1.09C27.301 0.760151 27.0348 0.484975 26.7111 0.293228C26.3874 0.101481 26.0182 0.000209298 25.642 0H9.00197C8.44501 0 7.91087 0.221255 7.51704 0.615082C7.12322 1.00891 6.90198 1.54305 6.90198 2.10001V33.9C6.90198 34.4808 7.13271 35.0379 7.54341 35.4486C7.95412 35.8593 8.51116 36.09 9.09198 36.09H46.892C47.4728 36.09 48.0298 35.8593 48.4405 35.4486C48.8512 35.0379 49.082 34.4808 49.082 33.9V6.13C49.082 5.57305 48.8607 5.03891 48.4669 4.64508C48.0731 4.25125 47.5389 4.03 46.982 4.03H30.192C29.8655 4.03123 29.5447 3.94462 29.2632 3.77924C28.9817 3.61385 28.7498 3.37579 28.592 3.09Z"
                              fill="#037DB1"></path>
                        <path opacity="0.3"
                              d="M28.592 3.09L27.482 1.09C27.301 0.760151 27.0348 0.484975 26.7111 0.293228C26.3874 0.101481 26.0182 0.000209298 25.642 0H9.00197C8.44501 0 7.91087 0.221255 7.51704 0.615082C7.12322 1.00891 6.90198 1.54305 6.90198 2.10001V33.9C6.90198 34.4808 7.13271 35.0379 7.54341 35.4486C7.95412 35.8593 8.51116 36.09 9.09198 36.09H46.892C47.4728 36.09 48.0298 35.8593 48.4405 35.4486C48.8512 35.0379 49.082 34.4808 49.082 33.9V6.13C49.082 5.57305 48.8607 5.03891 48.4669 4.64508C48.0731 4.25125 47.5389 4.03 46.982 4.03H30.192C29.8655 4.03123 29.5447 3.94462 29.2632 3.77924C28.9817 3.61385 28.7498 3.37579 28.592 3.09Z"
                              fill="white"></path>
                        <path d="M43.8221 5.30005H11.5721V29.41H43.8221V5.30005Z" fill="#202A4D"></path>
                        <path opacity="0.8" d="M43.8221 5.30005H11.5721V29.41H43.8221V5.30005Z" fill="white"></path>
                        <path d="M46.1521 7.71997H9.24207V35.32H46.1521V7.71997Z" fill="#202A4D"></path>
                        <path opacity="0.9" d="M46.1521 7.71997H9.24207V35.32H46.1521V7.71997Z" fill="white"></path>
                        <path d="M52.7721 8.40998H30.6621C30.2108 8.38837 29.7601 8.46077 29.3383 8.62258C28.9165 8.7844 28.533 9.03211 28.2121 9.34999L26.7721 11.09C26.5098 11.3665 26.1908 11.583 25.8369 11.7246C25.483 11.8661 25.1027 11.9294 24.7221 11.91H3.12206C1.62206 11.91 0.622057 12.72 0.882057 13.72C2.99206 21.91 4.05206 26 6.16206 34.18C6.35172 34.7319 6.70909 35.2107 7.18421 35.5496C7.65934 35.8885 8.22847 36.0704 8.81205 36.07H46.2921C46.8756 36.0704 47.4448 35.8885 47.9199 35.5496C48.395 35.2107 48.7524 34.7319 48.9421 34.18L55.1221 10.23C55.3721 9.22998 54.3321 8.40998 52.7721 8.40998Z"
                              fill="#037DB1"></path>
                        <g opacity="0.6">
                            <path d="M52.7721 8.40998H30.6621C30.2108 8.38837 29.7601 8.46077 29.3383 8.62258C28.9165 8.7844 28.533 9.03211 28.2121 9.34999L26.7721 11.09C26.5098 11.3665 26.1908 11.583 25.8369 11.7246C25.483 11.8661 25.1027 11.9294 24.7221 11.91H3.12206C1.62206 11.91 0.622057 12.72 0.882057 13.72C2.99206 21.91 4.05206 26 6.16206 34.18C6.35172 34.7319 6.70909 35.2107 7.18421 35.5496C7.65934 35.8885 8.22847 36.0704 8.81205 36.07H46.2921C46.8756 36.0704 47.4448 35.8885 47.9199 35.5496C48.395 35.2107 48.7524 34.7319 48.9421 34.18L55.1221 10.23C55.3721 9.22998 54.3321 8.40998 52.7721 8.40998Z"
                                  fill="white"></path>
                        </g>
                    </svg>
                </div>
                <div class="billing-card__description" *ngIf="data.text">
                    <div class="billing-card__content" [innerHTML]="data.text | storyblokRichtext">
                    </div>
                </div>
            </ng-template>

            <div class="billing-card__button">
                <button class="btn btn--secondary w-100" (click)="openFormModal({ action: 'update', title: 'Edit Billing', url: '' })">
                    {{ 'Edit' | translate}}
                </button>
            </div>
        </div>
    </ng-container>

    <ng-template [ngIf]="!formLoading && editting">
        <form [formGroup]="form" novalidate (ngSubmit)="submit(form.value, form?.valid, urlAPI)"
              class="mat-form editting-form" #formDirective="ngForm">
            <div *ngIf="errorMessage.length > 0" class="row form-group" role="alert">
                <div class="col-md-10">
                    <div class="alert alert-danger">
                        <div *ngFor="let error of errorMessage">
                            <i class="fas fa-exclamation-circle" aria-hidden="true"></i>
                            {{ error | translate }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mb-2">
                <div class="col-xs-6">
                    <label class="editting-form editting-form__col__field me-form-input"
                           [class.error]="!(form.controls.first_name.valid
                                                || (form.controls.first_name.pristine && !submitted))">
                        <div class="">{{'First Name' | translate}}*</div>
                        <input type="text"
                               required="required"
                               formControlName="first_name"/>
                    </label>
                    <small class="form-text text-danger"
                           [hidden]="form.controls?.first_name?.valid || (form.controls?.first_name?.pristine && !formSubmitted)">
                        {{ 'Field is required' | translate }}
                    </small>
                </div>

                <div class="col-xs-6">
                    <label class="editting-form editting-form__col__field me-form-input"
                           [class.error]="!(form.controls.last_name.valid
                                                || (form.controls.last_name.pristine && !submitted))">
                        <div class="">{{'Last Name' | translate}}*</div>
                        <input type="text"
                               required="required"
                               formControlName="last_name"/>
                    </label>
                    <small class="form-text text-danger"
                           [hidden]="form.controls?.last_name?.valid || (form.controls?.last_name?.pristine && !formSubmitted)">
                        {{ 'Field is required' | translate }}
                    </small>
                </div>
            </div>

            <div class="row mb-2">
                <div class="col-xs-12">
                    <label class="editting-form editting-form__col__field me-form-input w-100"
                           [class.error]="!(form.controls.street.valid
                                                || (form.controls.street.pristine && !submitted))">
                        <div class="">{{ 'Adress' | translate }}*</div>
                        <input type="text"
                               class="w-100"
                               required="required"
                               formControlName="street"/>
                    </label>
                    <small class="form-text text-danger"
                           [hidden]="form.controls?.street?.valid || (form.controls?.street?.pristine && !formSubmitted)">
                        {{ 'Field is required' | translate }}
                    </small>
                </div>
            </div>

            <div class="row mb-2">
                <div class="col-xs-6">
                    <label class="editting-form editting-form__col__field me-form-input"
                           [class.error]="!(form.controls.postal_code.valid
                                                || (form.controls.postal_code.pristine && !submitted))">
                        <div class="">{{ 'Zip code' | translate }}*</div>
                        <input type="text"
                               required="required"
                               formControlName="postal_code"/>
                    </label>
                    <small class="form-text text-danger"
                           [hidden]="form.controls?.postal_code?.valid || (form.controls?.postal_code?.pristine && !formSubmitted)">
                        {{ 'Field is required' | translate }}
                    </small>
                </div>

                <div class="col-xs-6">
                    <label class="editting-form editting-form__col__field me-form-input"
                           [class.error]="!(form.controls.city.valid
                                                || (form.controls.city.pristine && !submitted))">
                        <div class="">{{ 'City' | translate }}*</div>
                        <input type="text"
                               class=""
                               required="required"
                               formControlName="city"/>
                    </label>
                    <small class="form-text text-danger"
                           [hidden]="form.controls?.city?.valid || (form.controls?.city?.pristine && !formSubmitted)">
                        {{ 'Field is required' | translate }}
                    </small>
                </div>
            </div>

            <div class="row">
                <div class="col-xs-12 text-xs-right">
                    <button type="button" class="btn btn--secondary mr-r--sm" (click)="editting = false">
                        {{ 'Cancel' | translate }}
                    </button>
                    <button type="submit"
                            [class.disabled]="!form.valid"
                            class="btn btn--primary save">
                        {{ 'Save' | translate }}
                    </button>
                </div>
            </div>
        </form>
    </ng-template>
</div>